module.exports = __webpack_public_path__ + "img/playStore.ab0c32da.png";